import { lazy } from "react";

const SuperAdminLogin = lazy(() => import("../user/SuperAdminLogin.jsx"));
const UserLogin = lazy(() => import("../user/LogIn.jsx"));
const ForgotPassword = lazy(() => import("../user/ForgotPassword.jsx"));
const ResetPassword = lazy(() => import("../user/ResetPassword.jsx"));
const RegistroTenant = lazy(() => import("../public/RegistroTenant.jsx"));
const VerificarEmail = lazy(() => import("../public/VerificarEmail.jsx"));
const CompraQRCaptura = lazy(() => import("../compras/qr/CompraQRCaptura.jsx"));

const authRoutes = [
      { path: "/super-admin", element: <SuperAdminLogin /> },
      {
            path: "/login",
            element: <UserLogin />,
      },
      {
            path: "/forgot-password",
            element: <ForgotPassword />,
      },
      {
            path: "/reset-password/:token",
            element: <ResetPassword />,
      },
      {
            path: "/sign-up",
            element: <RegistroTenant />,
      },
      {
            path: "/public/verificar-email",
            element: <VerificarEmail />,
      },
      {
            path: "/compras/qr/:token",
            element: <CompraQRCaptura />,
      },
];

export default authRoutes;